import React from "react";

export default function Eleven({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M259.93.91H41.08a3.9,3.9,0,0,0-3.9,3.89V295a3.9,3.9,0,0,0,3.9,3.89H259.93a3.9,3.9,0,0,0,3.9-3.89V4.8A3.9,3.9,0,0,0,259.93.91ZM70.27,73.64H231.43v5.2H70.27ZM232,263.81a3.85,3.85,0,0,1-3.85,3.85H73.81A3.85,3.85,0,0,1,70,263.81V107.9A3.85,3.85,0,0,1,73.81,104H228.17A3.85,3.85,0,0,1,232,107.9Z" />
      {children}
    </svg>
  );
}
